module.exports = __webpack_public_path__ + "static/dziad-029094b00b55b1a6bb34b2b307e0403a.png";